// Primary nav (RESTYLE §2, §6; components.css §1). Inside the 1180px column: the mark (it scans while any run
// is live) + the Inter Tight 200 wordmark, mono links (2px accent underline on the current one), then the fleet
// readout, the bulk-quota badge (signed-in only), the account control and the theme toggle, which floats outside
// the column from 1300px. Transparent at the top of the page, opaque paper with a hairline once scrolled. Under
// 900px the fleet readout drops out.
//   <Nav />   reads the route, nodes, jobs, config and session itself
import { Link, NavLink } from "react-router-dom";
import { Mark } from "@/components/ui";
import { useScrolled } from "@/hooks";
import { Account } from "./Account";
import { BulkBadge } from "./BulkBadge";
// FleetReadout no longer renders in the nav — it took vertical space on
// every page just to show '2/2 slots free · 1 node' which is only
// actionable to someone about to submit. Moved into the SubmitPage
// hero instead; still visible in the thin status footer everywhere.
import { NavSearch } from "./NavSearch";
import { ThemeToggle } from "./ThemeToggle";
import { useLiveRuns } from "./useLiveRuns";

const LINKS: { to: string; label: string; end?: boolean }[] = [
  { to: "/submit", label: "Submit" },
  { to: "/jobs", label: "Analyses" },
  { to: "/docs", label: "Docs" },
];

export function Nav() {
  const scrolled = useScrolled(4);
  const live = useLiveRuns();
  return (
    <header className="nav" data-scrolled={scrolled}>
      <div className="nav-in">
        <Link className="brand" to="/" viewTransition aria-label="malbox home">
          <Mark className="brand-mark" scan={live.count > 0} />
          <span className="wordmark">malbox</span>
        </Link>
        <nav className="nav-links" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink key={l.to} className="nav-link" to={l.to} end={l.end} viewTransition>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="nav-right">
          <NavSearch />
          <BulkBadge />
          <Account />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
